import React, { Component } from "react"
import BirthDetails from "./BirthDetails"
import { VIEW_GROUP_NGO } from "helpers/view_helper"
import BirthDetailsNGO from "./BirthDetailsNGO"
import { getGroupType } from "components/Common/Roles"

class BirthDetailsWelcomePage extends Component {
    constructor(props) {
        super(props)

        this.state = {
            groupType: ''
        }
    }

    componentDidMount() {
        console.log("BirthDetailsWelcomePage->componentDidMount->called")
        let groupType = getGroupType()
        this.setState({
            groupType
        })
    }

    render() {
        let groupType = this.state.groupType
        if (groupType === VIEW_GROUP_NGO) {
            return (
                <BirthDetailsNGO history={this.props.history} />
            )
        } else {
            return (
                <BirthDetails history={this.props.history} />
            )
        }
    }
}

export default BirthDetailsWelcomePage
